import {
  Component,
  inject,
  Input,
  signal,
  SimpleChanges,
  OnChanges,
  OnInit,
  ViewChild,
  ElementRef
} from '@angular/core';
import { FriendsService } from '../service/friends.service';
import { IRequest, IRequestsResponse } from '../model/friends.model';
import { exhaustMap, finalize, of, Subscription } from 'rxjs';
import { FormsModule } from '@angular/forms';
import { RequestCardComponent } from '../request-card/request-card.component';

@Component({
  selector: 'app-requests-list',
  standalone: true,
  imports: [FormsModule, RequestCardComponent],
  templateUrl: './requests-list.component.html',
  styleUrls: ['./requests-list.component.scss'],
})
export class RequestsListComponent implements OnChanges, OnInit {
  @Input() tabUpdated!: number;
  @ViewChild('scrollRequestsContainer', { static: false }) scrollRequestsContainer!: ElementRef;

  private subscriptions = new Subscription();

  friendsService = inject(FriendsService);
  requestsList = signal<IRequest[]>([]);
  protected requestsTotal = this.friendsService.requestTotal
  private isRequestsFetching = false;
  private allRequestsLoaded = false;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['tabUpdated'].currentValue === 2) {
      this.getInitialRequests();
    }
  }

  ngOnInit() {
    this.getInitialRequests();
  }

  getInitialRequests() {
    this.subscriptions.add(
      this.friendsService.getRequests(50).subscribe((requests) => {
        if (requests.data) {
          this.requestsTotal.set(requests.total)
          this.requestsList.set(requests.data)
        }
      }),
    );
  }

  onEvent(requestId: number) {
    const list = this.requestsList();

    this.requestsList.set(list.filter((f) => f.id !== requestId));
    this.requestsTotal.set(this.requestsList().length);
    this.friendsService.setRequestTotal(this.requestsList().length);
  }

  onRequestsScroll() {
    const container = this.scrollRequestsContainer.nativeElement;
    const bottomReached = container.scrollTop + container.clientHeight >= container.scrollHeight - 200; // 50px buffer

    if (bottomReached && !this.allRequestsLoaded && !this.isRequestsFetching) {
      this.loadMoreRequests();
    }
  }

  loadMoreRequests() {
    if (this.allRequestsLoaded || this.isRequestsFetching) return;

    this.isRequestsFetching = true;

    this.friendsService
      .getRequests(50, this.requestsList().length)
      .pipe(
        exhaustMap((requestsResponse: IRequestsResponse) => {
          if (requestsResponse.data.length) {
            this.requestsList.update((list) => [...list, ...requestsResponse.data]);
            this.allRequestsLoaded = requestsResponse.total <= this.requestsList().length;
            this.requestsTotal.set(requestsResponse.total);
            this.friendsService.setFriendsTotal(requestsResponse.total);
          }
          return of(null);
        }),
        finalize(() => (this.isRequestsFetching = false)),
      )
      .subscribe();
  }
}
